<template>
  <div class="qr-code">
    <div class="line">
      <span class="line-left"></span><span class="line-msg">或扫码联系客户顾问</span><span class="line-right"></span>
    </div>
    <div class="line-text">即刻沟通</div>
    <img :src="angle" class="qrcode-angle">
    <img :src="qrcode" class="qrcode-qrcode">
  </div>
</template>

<script>
export default {
  name: 'QrCode',
  data () {
    return {
      angle: require('@assets/images/advertise/13.svg'),
      qrcode: require('@assets/images/advertise/footer_qrcode.png'),
    }
  }
}
</script>

<style lang="scss" scoped>
@import './QrCode.scss';
</style>